import { render, staticRenderFns } from "./Advertisement.vue?vue&type=template&id=01de8b02&scoped=true&"
import script from "./Advertisement.vue?vue&type=script&lang=js&"
export * from "./Advertisement.vue?vue&type=script&lang=js&"
import style0 from "./Advertisement.vue?vue&type=style&index=0&id=01de8b02&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01de8b02",
  null
  
)

export default component.exports